import { exportSpecData, importSpecData } from '../../../api/setting'
export default {
  ExportData({ commit }, params) {
    const formData = params.formController.getFormData()
    const el = params.viewController.view.content[1].$el
    if (formData && formData.industryId) {
      el.buildStatus = 'EX' + Date.now()
      exportSpecData({ id: formData.industryId }).then(response => {})
    } else {
      this.dispatch('OpenNotification', { message: '请先选择行业', type: 'warning' })
    }
  },
  ImportData({ commit }, params) {
    const el = params.viewController.view.content[1].$el
    el.buildStatus = 'IM' + Date.now()
    importSpecData({}).then(response => {})
  }
}
